import {H1, H2} from 'components/Typography';
import {FC} from 'react';
import {useBackend} from 'state/backend';
import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';
import {Backend} from 'types/api';

import PartnerTable from './PartnerTable';
import {Partner, User} from './types';
import UserTable from './UserTable';

export type ProfileNotificationBackendData = Backend<{
    partners: Partner[];
    teamActivityDisabledSettingsList: string[];
    user: User;
}>;

const ProfileNotification: FC = () => {
    const {
        data: {partners, teamActivityDisabledSettingsList, user},
    } = useBackend<ProfileNotificationBackendData>();

    const teamActivityDisabledSettingsSet = new Set(
        teamActivityDisabledSettingsList,
    );

    return (
        <>
            <H1>{t`Notification Settings`}</H1>
            <H2>{t`Product Notifications`}</H2>
            <UserTable user={user} />
            {partners && partners.length > 0 && (
                <>
                    <H2 className="mt-10">
                        {t`Account Activity Notifications`}
                    </H2>
                    {partners.map((partner, index) => (
                        <PartnerTable
                            className={twMerge(
                                partners.length - 1 === index && 'mb-8',
                            )}
                            key={partner.mid}
                            partner={partner}
                            teamActivityDisabledSettingsSet={
                                teamActivityDisabledSettingsSet
                            }
                        />
                    ))}
                </>
            )}
        </>
    );
};

export default ProfileNotification;
